<section>
    <div class="annex-container">
        <h1 class="header-3">Annex I to the Aptoide Connect Certified Developer Distribution Agreement</h1>
        <h4 class="center no-margin-top bottom-margin">MoR Territories</h4>
        <p class="s">
            If you choose to do so in your Certified Developer Account, for the purposes of Clause 4.3. of this Agreement, Aptoide may, acting as your commercial agent, be the merchant of record in
            relation to the In-App Products sold through Aptoide App Store and certain Partner Stores to Users located in the following territories/countries
            <span class="small bold">and provided that Certified Developer and Partner Stores have integrated Aptoide Connect billing system into its Apps/Stores</span>:
        </p>

        <div class="two-column-container">
            <div class="row">
                <div class="col">
                    <p class="s">Åland Islands</p>
                </div>
                <div class="col">
                    <p class="s">Lithuania</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Austria</p>
                </div>
                <div class="col">
                    <p class="s">Luxembourg</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Belgium</p>
                </div>
                <div class="col">
                    <p class="s">Malta</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Bulgaria</p>
                </div>
                <div class="col">
                    <p class="s">Martinique</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Ceuta</p>
                </div>
                <div class="col">
                    <p class="s">Mayotte</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Croatia</p>
                </div>
                <div class="col">
                    <p class="s">Melilla</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Republic of Cyprus</p>
                </div>
                <div class="col">
                    <p class="s">Monaco</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Czech Republic</p>
                </div>
                <div class="col">
                    <p class="s">Netherlands</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Denmark</p>
                </div>
                <div class="col">
                    <p class="s">New Caledonia</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Estonia</p>
                </div>
                <div class="col">
                    <p class="s">Norway</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Faroe Islands</p>
                </div>
                <div class="col">
                    <p class="s">Poland</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Finland</p>
                </div>
                <div class="col">
                    <p class="s">Portugal</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">France</p>
                </div>
                <div class="col">
                    <p class="s">Réunion</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">French Guiana</p>
                </div>
                <div class="col">
                    <p class="s">Romania</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">French Polynesia</p>
                </div>
                <div class="col">
                    <p class="s">Saint Barthélemy</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Gibraltar</p>
                </div>
                <div class="col">
                    <p class="s">Saint-Martin</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Germany</p>
                </div>
                <div class="col">
                    <p class="s">Saint Pierre and Miquelon</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Greece</p>
                </div>
                <div class="col">
                    <p class="s">San Marino</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Greenland</p>
                </div>
                <div class="col">
                    <p class="s">Santa Cruz de Tenerife</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Guadeloupe</p>
                </div>
                <div class="col">
                    <p class="s">Slovakia</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Holy See (Vatican City State)</p>
                </div>
                <div class="col">
                    <p class="s">Slovenia</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Hungary</p>
                </div>
                <div class="col">
                    <p class="s">Spain</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Iceland</p>
                </div>
                <div class="col">
                    <p class="s">Svalbard and Jan Mayen Islands</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Ireland</p>
                </div>
                <div class="col">
                    <p class="s">Sweden</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Italy</p>
                </div>
                <div class="col">
                    <p class="s">United Kingdom</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Las Palmas</p>
                </div>
                <div class="col">
                    <p class="s">Wallis and Futuna</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Latvia</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="s">Liechtenstein</p>
                </div>
            </div>
        </div>
    </div>
</section>
